import Form from 'components/Profile/MedicalHistory/Form';

const MedicalHistory = () => <Form />;

export default MedicalHistory;
